// Mock data for Virtual Enterprise LTD

export const services = [
  {
    id: 1,
    title: "Administrative Support",
    description: "Efficient handling of scheduling, email management, data entry, and document organization to keep your business running smoothly.",
    icon: "Briefcase",
    accentClass: "accent-purple",
    features: ["Calendar Management", "Email Handling", "Data Entry", "Document Organization"]
  },
  {
    id: 2,
    title: "Customer Service",
    description: "Professional chat support, phone answering, and customer inquiry management to enhance your customer satisfaction.",
    icon: "Headphones",
    accentClass: "accent-blue",
    features: ["Live Chat Support", "Phone Answering", "Ticket Management", "Customer Relations"]
  },
  {
    id: 3,
    title: "Social Media Management",
    description: "Strategic content creation, posting schedules, community engagement, and analytics tracking across all platforms.",
    icon: "Share2",
    accentClass: "accent-orange",
    features: ["Content Creation", "Post Scheduling", "Community Engagement", "Analytics Reporting"]
  },
  {
    id: 4,
    title: "Content Creation",
    description: "High-quality writing, graphic design, video editing, and creative content tailored to your brand voice and vision.",
    icon: "PenTool",
    accentClass: "accent-pink",
    features: ["Blog Writing", "Graphic Design", "Video Editing", "Brand Content"]
  },
  {
    id: 5,
    title: "Technical Support",
    description: "Expert IT assistance, website maintenance, software troubleshooting, and technical issue resolution.",
    icon: "Settings",
    accentClass: "accent-green",
    features: ["IT Support", "Website Maintenance", "Software Troubleshooting", "System Updates"]
  },
  {
    id: 6,
    title: "Project Management",
    description: "Comprehensive project coordination, timeline management, team communication, and deliverable tracking.",
    icon: "Target",
    accentClass: "accent-grey",
    features: ["Project Planning", "Timeline Management", "Team Coordination", "Progress Tracking"]
  }
];

export const pasaServices = [
  { text: "HRC preparation and submission", icon: "FileCheck" },
  { text: "ISP development and updates", icon: "ClipboardList" },
  { text: "Medicaid billing support", icon: "Receipt" },
  { text: "Appointment scheduling and coordination", icon: "CalendarClock" },
  { text: "Quality assurance and compliance monitoring", icon: "ShieldCheck" },
  { text: "Administrative support", icon: "Briefcase" },
  { text: "Responding to RFPs for new client opportunities", icon: "FileSignature" },
  { text: "Survey readiness and deficiency prevention", icon: "SearchCheck" }
];

export const pricingPlans = [
  {
    id: 1,
    name: "Basic",
    price: "8",
    period: "per hour",
    weeklyLimit: "Up to 40 hours/week",
    description: "Perfect for small tasks and occasional support needs",
    features: [
      "Up to 40 hours per week",
      "Email & Chat Support",
      "Basic Administrative Tasks",
      "Response within 24 hours",
      "Single Service Focus",
      "Flexible scheduling"
    ],
    popular: false,
    cta: "Get Started"
  },
  {
    id: 2,
    name: "Standard",
    price: "12",
    period: "per hour",
    weeklyLimit: "Up to 40 hours/week",
    description: "Ideal for growing businesses needing regular assistance",
    features: [
      "Up to 40 hours per week",
      "Priority Email & Phone Support",
      "Multi-Service Access",
      "Response within 12 hours",
      "Dedicated Account Manager",
      "Monthly Performance Reports"
    ],
    popular: true,
    cta: "Most Popular"
  },
  {
    id: 3,
    name: "Premium",
    price: "18",
    period: "per hour",
    weeklyLimit: "Up to 40 hours/week",
    description: "Comprehensive support for enterprises and high-volume needs",
    features: [
      "Up to 40 hours per week",
      "24/7 Priority Support",
      "Full Service Portfolio Access",
      "Immediate Response",
      "Dedicated Team Assignment",
      "Weekly Strategy Calls",
      "Custom Workflow Integration"
    ],
    popular: false,
    cta: "Contact Sales"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Mitchell",
    role: "Small Business Owner",
    content: "Virtual Enterprise LTD transformed our operations. Their administrative support freed up 15 hours a week, allowing me to focus on growing the business.",
    rating: 5,
    avatar: "SM"
  },
  {
    id: 2,
    name: "James Cooper",
    role: "Marketing Professional",
    content: "Outstanding social media management! Our engagement increased by 300% in just two months. Professional, reliable, and creative team.",
    rating: 5,
    avatar: "JC"
  },
  {
    id: 3,
    name: "Emily Rodriguez",
    role: "Business Founder",
    content: "The customer service support has been exceptional. Our clients love the quick response times and professional handling of inquiries.",
    rating: 5,
    avatar: "ER"
  },
  {
    id: 4,
    name: "Michael Chen",
    role: "Consultant",
    content: "Best investment for my business. The technical support and content creation services are top-notch. Highly recommend!",
    rating: 5,
    avatar: "MC"
  }
];

export const stats = [
  { value: "10+", label: "Clients Served" },
  { value: "1K+", label: "Hours Delivered" },
  { value: "98%", label: "Satisfaction Rate" },
  { value: "24/7", label: "Support Available" }
];

export const whyChooseUs = [
  {
    title: "Experienced Professionals",
    description: "Our team consists of skilled virtual assistants with years of experience across diverse industries.",
    icon: "Award"
  },
  {
    title: "Cost-Effective Solutions",
    description: "Save up to 70% compared to hiring full-time employees while maintaining premium quality service.",
    icon: "DollarSign"
  },
  {
    title: "Flexible & Scalable",
    description: "Scale your support up or down based on your business needs without long-term commitments.",
    icon: "TrendingUp"
  },
  {
    title: "Data Security",
    description: "We prioritize your data security with industry-standard encryption and confidentiality agreements.",
    icon: "Shield"
  }
];

// Mock function to simulate contact form submission
export const submitContactForm = async (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Contact form submitted:", formData);
      resolve({ success: true, message: "Thank you for your inquiry! We'll get back to you within 24 hours." });
    }, 1000);
  });
};

// Mock function to simulate booking
export const submitBooking = async (bookingData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Booking submitted:", bookingData);
      resolve({ success: true, message: "Your booking request has been received! We'll confirm your appointment shortly." });
    }, 1000);
  });
};
